(ns app.front.view.public-notice.decision-download
  (:require [app.front.file.download :as file-download]
            [app.front.util :as futil]
            [app.front.view.not-found :as not-found]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))

(rf/reg-sub ::decision-download
  (fn [db _]
    (-> db :view/decision-download)))


(rf/reg-sub ::fetch-status
  :<- [::decision-download]
  (fn [view _]
    (-> view :fetch-status)))


(rf/reg-sub ::decision-id
  :<- [::decision-download]
  (fn [view _]
    (-> view :decision-id)))


(rf/reg-sub ::token
  :<- [::decision-download]
  (fn [view _]
    (-> view :token)))


(rf/reg-event-db ::file-not-found
  (fn [db [_ _status _response]]
    (let [error :not-found]
      (update db :view/decision-download assoc :fetch-status error))))


(rf/reg-event-fx ::decode-success
  (fn [{:keys [db]} [_ token workspace-id _ id]]
    (let [file-id (long id)]
      {:db           (assoc db :view/decision-download
                            {:decision-id  file-id
                             :fetch-status :complete
                             :token        token})
       :comm/command {:command      :public-notice/check-decision-file
                      :data         {:file-id      file-id
                                     :workspace-id workspace-id}
                      :on-not-found [::file-not-found]}})))


(rf/reg-event-fx ::decode-file-token
  (fn [_ [_ token workspace-id]]
    {:comm/command {:command    :public-notice/decode-file-token
                    :data       {:user/token token}
                    :on-success [::decode-success token workspace-id]
                    :on-done    [::file-not-found]
                    :notify     {:error :public-notice-contact/decision-error}}}))


(defn decision-wrapper [workspace-id]
  (let [tr    (<sub [:tr])
        id    (<sub [::decision-id])
        token (<sub [::token])]
    [:div.my-5.mx-auto.max-w-2xl.justify-center.items-center
     [:section.rounded-lg
      [:div.flex.flex-col.justify-center.items-center
       [:div.flex.mt-5
        [:h3 (tr [:public-notice-contact/download-decision-file])]]
       [:div.flex.mb-5
        [file-download/download-council-decision-file-button id token workspace-id
         {:text (tr [:download])}]]]]]))


(defn decision-download [match]
  (let [workspace-id (-> match :parameters :path :workspace-id)
        fetch-status (<sub [::fetch-status])
        fetch-done?  (= fetch-status :complete)
        not-found?   (= fetch-status :not-found)]
    (cond
      fetch-done?
      [decision-wrapper workspace-id]
      not-found?
      [not-found/not-found-view]
      :else
      (cc/loading-spinner))))


(def route
  {:name        :view/decision-download
   :view        decision-download
   :own-layout? true
   :public?     true
   :parameters  {:path  {:workspace-id s/Str}
                 :query {:download s/Str}}
   :controllers [{:parameters {:path  [:workspace-id]
                               :query [:download]}
                  :start      (fn [params]
                                (futil/set-title "Download decision")
                                (>evt [::decode-file-token (-> params :query :download) (-> params :path :workspace-id)]))}]})
